import { combineReducers } from 'redux';

import { reducer as addUser } from './addUserModule';
import { reducer as removeUser } from './removeUserModule';

export default combineReducers({
	addUser,
	removeUser,
});
